import React from "react";
var __jsx = React.createElement;
import stl from "./CancelButton.module.css";
import { useTranslation } from "@i18n";
var CancelButton = function CancelButton(_ref) {
  var onClick = _ref.onClick,
    className = _ref.className,
    isArrow = _ref.isArrow;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("button", {
    onClick: onClick,
    className: "".concat(stl.button, " ").concat(className || "")
  }, isArrow && /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.2925 16.2875L13.1725 12.4075L9.2925 8.5275C8.9025 8.1375 8.9025 7.5075 9.2925 7.1175C9.6825 6.7275 10.3125 6.7275 10.7025 7.1175L15.2925 11.7075C15.6825 12.0975 15.6825 12.7275 15.2925 13.1175L10.7025 17.7075C10.3125 18.0975 9.6825 18.0975 9.2925 17.7075C8.9125 17.3175 8.9025 16.6775 9.2925 16.2875Z",
    fill: "#154F9C"
  })), !isArrow && t("cancel", {
    ns: "web_common"
  }));
};
export default CancelButton;